import { createActionGroup, props } from '@ngrx/store';
import { CustomRecentInputKeys } from '@shared/forms/custom-recent-input/data/custom-recent-input-keys.directory';

export const recentInputActions = createActionGroup({
  source: 'RecentInput',
  events: {
    addRecentInput: props<{ key: CustomRecentInputKeys; value: string }>(),
    removeRecentInput: props<{ key: CustomRecentInputKeys; value: string }>(),
  },
});
